import React from "react";
import FacebookIcon from '../Icons/FacebookIcon.jsx';
import TelegramIcon from '../Icons/TelegramIcon.jsx';
import InstagramIcon  from '../Icons/InstagramIcon.jsx';

import { RiAdminLine } from "react-icons/ri";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import "./Footer.scss";

const Footer = () => {
  const { isSeller } = useSelector((state) => state.seller);

  return (
    <div className="footer-container">
      <div className="social-links">
      <div className="textcont">
      <div className="bigtext">Ми в соціальних мережах:</div>
      <div className="smalltext">Звертайтесь в Telegram, пишіть на Email щоб отримати підтримку або дізнатись про нас більше.</div>
      </div>
      <Link to="https://www.instagram.com/meblim.m/">
      <div className="social-link">
              <InstagramIcon />
              <div className="social-texts">
                <h3 className="title">Instagram</h3>
                <p className="username">@meblim.m</p>
              </div>
            </div>
            </Link>

            <Link to="/">
            <div className="social-link">
              <TelegramIcon className="icon" />
              <div className="social-texts">
                <h3 className="title">Telegram</h3>
                <p className="username">@MebliM_support</p>
              </div>
            </div>
            </Link>

            <Link to="/">
            <div className="social-link">
              <FacebookIcon className="icon"/>
              <div className="social-texts">
                <h3 className="title">Facebook</h3>
                <p className="username">@MebliM_support</p>
              </div>
            </div>
            </Link>
            {isSeller && (
            <Link to={`${isSeller ? "/dashboard" : "/"}`} className="link">
            <div className="social-link">
              <RiAdminLine   className="icon" />
              <div className="social-texts">
                <h3 className="title">{isSeller ? "Панель керування" : ""}</h3>
                <p className="username">{isSeller ? "Клікни сюди якщо ти адмін)" : ""}</p>
              </div>
            </div>
            </Link>
            )}
          </div>

      <div className="footer-bottom">
        <span>© 1990-2024 MebliM. All rights reserved.</span>
        <span><Link  to={"/terms"}>Умови</Link> ·<Link  to={"/policy"}> Політика приватності</Link></span>
      </div>
    </div>
  );
};

export default Footer;
